import { render, staticRenderFns } from "./repeater.vue?vue&type=template&id=473ffda0&scoped=true&"
import script from "./repeater.vue?vue&type=script&lang=js&"
export * from "./repeater.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473ffda0",
  null
  
)

export default component.exports